import { useParams } from "react-router";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";
import { usePageTitle } from "../hooks/usePageTitle";

export function ResetPasswordPage() {
  usePageTitle("Reset password | TidyRota");
  const { token } = useParams<{ token: string }>();

  if (!token) return null;

  return (
    <AuthLayout>
      <ResetPasswordForm token={token} />
    </AuthLayout>
  );
}
